import React from "react"
import { HomeHero } from "./homeHero"
import { Header } from "./header"
import MobileHeader from "./mobileHeader"
import About from "./about"
import Portfolio from "./portfolio"
import { useNavContext } from "../contexts/navContext"
import { css } from "@emotion/react"
import { useImages } from "../contexts/imageContext"
import { useFeaturedContext } from "../contexts/featuredContext"
import { HashLoader } from "react-spinners"
import { useAbout } from "../contexts/aboutContext"
import ContactForm from "./contact"
import Footer from "./Footer"
import { SideName } from "./sideName"
import { Outlet } from "react-router-dom"

export function Body() {
  const overide = css`
    display: block;
  `
  const [images] = useImages()
  const about = useAbout()
  const featured = useFeaturedContext()
  const toggler = useNavContext()
  if (!images || !featured || !about)
    return (
      <div className="loader-screen d-flex align-items-center justify-content-center">
        <HashLoader color={"#28e0cb"} loading={true} size={80} css={overide} />
        <small className="text-center mt-5 text-uppercase d-block fw-bold">
          Time to see what i'm made of 🐱‍💻
        </small>
      </div>
    )
  else
    return (
      <>
        <Header />
        <MobileHeader />
        <div className={toggler.toggle ? "blur" : ""}>
          {/* <HomeHero />
          <About />
          <Portfolio />
          <ContactForm />
          <Footer /> */}
          <Outlet />
          <SideName />
        </div>
      </>
    )
}
